// extracted by mini-css-extract-plugin
export default {"article_card__main":"Articles_article_card__main__5fETk","article_header__actions":"Articles_article_header__actions__wkmUc"};